/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerRatingExplanation = {
    properties: {
        maxScoreNormalize: {
            type: 'number',
            isRequired: true,
        },
        minScoreNormalize: {
            type: 'number',
            isRequired: true,
        },
        localMaxScore: {
            type: 'number',
            isRequired: true,
        },
        localMinScore: {
            type: 'number',
            isRequired: true,
        },
        playerScores: {
            type: 'array',
            contains: {
                type: 'SinglePlayerRatingExplanation',
            },
            isRequired: true,
        },
    },
} as const;
